<template>
  <recipe :recipe-name="recipeName" :pre-pack="prePack" :post-pack="postPack">
    <template v-slot:pre-pack>
      <div class="markdown" v-html="$options.filters.parseMd(prePack)" />
    </template>
    <!--
    <template v-slot:pack-widget>
      <p>This is a totally custom widget.</p>
    </template>
    <template v-slot:post-pack>
      <span>and ship!</span>
    </template>
    -->
  </recipe>
</template>
<script>
import { recipeCustom } from '~/components/recipes/mixins/custom'
export default {
  name: 'DoccurateItemToPalletPremadePallet',
  mixins: [recipeCustom]
}
</script>
